import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function C() {
    const { useLang } = useGlobal();
    const { t } = useLang('solar60w');
    return (
        <div className={`solar-60w-C ${css['solar-60w-C']}`}>
            <div className="text-box">
                <p className="title">{t('sec3_title')}</p>
                <p className="desc">
                    {t.rich('sec3_desc', {
                        black: (text: string) => <span className="black">{text}</span>,
                    })}
                </p>
            </div>
            <div className="img">
                <NextImage src={require('@publicLocal/solar-60w/pc/3.jpg')} alt={t('sec3_title')} aria-label={t('sec3_title')} />
            </div>
        </div>
    );
}
